import type { Menu } from "@/contexts/SidebarContext";
import { findMenuTrail } from "@/utils/menuNavigation";
import { NextRouter } from "next/router";

interface BreadcrumbItem {
  title: string;
  path?: string;
}

export function generateBreadcrumbs(menus: Menu[], router: NextRouter): BreadcrumbItem[] {
  const query = router.query as Record<string, string | string[] | undefined>;
  const trail = findMenuTrail(menus, router.asPath || router.pathname);
  if (trail.length > 0) {
    return trail
      .filter((item) => item.breadcrumb?.show !== false)
      .map((item) => ({
        title:
          typeof item.breadcrumb?.title === "function"
            ? item.breadcrumb.title(
                Object.fromEntries(
                  Object.entries(query).map(([key, value]) => [
                    key,
                    Array.isArray(value) ? value[0] || "" : value || ""
                  ])
                )
              )
            : item.breadcrumb?.title || item.title,
        path: replaceDynamicSegments(item.path, query)
      }));
  }

  return router.pathname
    .split("/")
    .filter(Boolean)
    .map((segment, index, segments) => ({
      title: segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " "),
      path: "/" + segments.slice(0, index + 1).join("/")
    }));
}

const replaceDynamicSegments = (
  path: string | undefined,
  query: Record<string, string | string[] | undefined>
): string | undefined => {
  if (!path) return undefined;
  return path.replace(/\[([^\]]+)\]/g, (_match, key: string) => {
    const value = query[key];
    return Array.isArray(value) ? value[0] || "" : value || "";
  });
};
